import { Component, PropsWithChildren } from 'react'

import { createReactInlineContentSpec } from '@blocknote/react'

import { VariableInlineContentWidget } from './VariableInlineContentWidget'

export const VariableInlineContent = createReactInlineContentSpec(
  {
    type: 'variable' as const,
    propSchema: { variableType: { default: '' } },
    content: 'styled'
  },
  {
    render: props => (
      <ErrorBoundary>
        <VariableInlineContentWidget contentRef={props.contentRef} />
      </ErrorBoundary>
    )
  }
)

/**
 * The `useCubeContext` hook in VariableInlineContentWidget throws an error when loading a quote template with variables,
 * because Cube is uninitialised. My hunch is that the schema code gets evaluated outside the normal React render loop.
 * To fix for now, I've wrapped the component in an error boundary (not the Sentry one to avoid unnecessary logging),
 * but a long term fix would to be to assemble the Blocknote schema in a useMemo so it's done in the normal React
 * render loop.
 */
class ErrorBoundary extends Component<
  PropsWithChildren,
  { hasError: boolean }
> {
  constructor(props: PropsWithChildren) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) return null
    return this.props.children
  }
}
